const STATS = [
  { value: "Since 2022", label: "Building Stars" },
  { value: "150+", label: "Players Trained" },
  { value: "U8 → Senior", label: "All Age Groups" },
  { value: "Witbank", label: "Our Home" },
  { value: "3×", label: "Sessions Per Week" },
  { value: "100%", label: "Passion. Always." },
];

export default function StatsStrip() {
  const items = [...STATS, ...STATS];

  return (
    <section
      data-testid="stats-strip"
      className="relative z-10 border-y border-white/10 bg-black overflow-hidden"
    >
      <div className="flex animate-marquee w-max">
        {items.map((s, i) => (
          <div
            key={i}
            className="flex items-baseline gap-4 px-10 py-6 border-r border-white/10 whitespace-nowrap"
          >
            <span className="font-heading uppercase text-red-600 text-3xl font-bold tracking-tight">
              {s.value}
            </span>
            <span className="text-xs uppercase tracking-widest text-white/60">
              {s.label}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
